import LoginPage from 'pages/LoginPage';
import HomePage from 'pages/HomePage';
import UserPage from 'pages/UserPage';

import AuthGuard from 'components/Guards/AuthGuard';
import Layouts from 'layouts/index';

import * as Routes from 'routes/core/RouterConstants';

const routes = [
  {
    element: <Layouts.MainLayout />,
    children: [
      {
        path: Routes.LOGIN_ROUTE,
        element: <LoginPage />,
      },
      {
        path: Routes.HOME_ROUTE,
        element: (
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        ),
      },
      {
        path: Routes.USER_ROUTE,
        element: (
          <AuthGuard>
            <UserPage />
          </AuthGuard>
        ),
      },
    ],
  },
];

export default routes;
